import pwaAppIcon from '../assets/Home/Vardaan V icon.png';

/** Bundled icon — avoids broken public-folder paths on Android (SW / basename). */
export const PWA_INSTALL_APP_ICON = pwaAppIcon;
